import type { ResumeDto } from "@stylingcv/dto";

import { axios } from "@/client/libs/axios";

export const findResumeById = async (data: { id: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/${data.id}`);

  return response.data;
};

export const findResumeByUsernameSlug = async (data: { username: string; slug: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/public/${data.username}/${data.slug}`);

  return response.data;
};

export type CreateCoverLetterParams = {
  sourceResumeId: string;
  body: string;
  jobTitle: string;
  companyName: string;
  recipientName?: string;
  recipientTitle?: string;
  tone?: string;
};

export type CoverLetterDocument = ResumeDto & {
  sourceResume?: { id: string; title: string } | null;
};

/**
 * Create a cover letter document linked to a source resume
 */
export const createCoverLetterDocument = async (params: CreateCoverLetterParams): Promise<CoverLetterDocument> => {
  const { sourceResumeId, ...body } = params;
  const response = await axios.post<CoverLetterDocument>(`/resume/${sourceResumeId}/cover-letter`, body);
  return response.data;
};

export type TranslateResumeParams = {
  sourceResumeId: string;
  targetLanguage: string;
  sourceLanguage?: string;
};

export type TranslateResumeResponse = ResumeDto & {
  fieldsTranslated: number;
};

export const translateResume = async (params: TranslateResumeParams): Promise<TranslateResumeResponse> => {
  const { sourceResumeId, ...body } = params;
  const response = await axios.post<TranslateResumeResponse>(`/resume/${sourceResumeId}/translate`, body);
  return response.data;
};
